import axios from "axios";

const removeFieldVideoWithoutEvent = async (videoId) => {
  const token = localStorage.getItem("token");
  const result = await axios.delete(
    `${process.env.REACT_APP_URL_BACKEND}api/v1/field-video/${videoId}`,
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
    }
  );
  const data = await result.data;
  return data;
};

export default removeFieldVideoWithoutEvent;
